import styles from './App.module.css'
import { Header } from './pages/layout/Header'
import { ContextProvider } from './utils/context'
import React, { useContext, useEffect } from 'react'
import { Context } from './utils/context'
import { Login } from './pages/login/Login'
import { Main } from './pages/layout/Main'
import { Settings } from './pages/settings/Settings'
import {
    Navigate,
    BrowserRouter as Router,
    Routes,
    Route,
    useLocation,
} from 'react-router-dom'
import { Accounts } from './pages/accounts/Accounts'
import { Reports } from './pages/reports/Reports'
import Loader from 'react-spinners/BounceLoader'
import useIdleTimer from './hooks/useIdleTimer'
import { Notifications } from './pages/layout/Notifications'
import { BetHistory } from './pages/layout/BetHistory'
import { Games } from './pages/settings/Games'
import { RightSidebar } from './pages/layout/types'
import { Accounting } from './pages/accounting/Accounting'

const ProtectedRoute = (props: { children: React.ReactNode }) => {
    const { children } = props
    const { loggedInUser, setLoggedInUser, isRightSidebarOpen } =
        useContext(Context)
    const location = useLocation()
    const isActive = useIdleTimer()

    useEffect(() => {
        // log out the user automatically after one hour of inactivity
        if (!isActive) {
            setLoggedInUser(null)
        }
    }, [isActive, setLoggedInUser])

    if (loggedInUser === null) {
        return <Navigate to="/login" state={{ from: location }} replace />
    }

    if (loggedInUser === undefined) {
        return (
            <div className={styles.loading_container}>
                <Loader loading={true} size={48} color={'var(--dark1)'} />
            </div>
        )
    }

    return (
        <div className={styles.content}>
            {children}
            {isRightSidebarOpen === RightSidebar.NOTIFICATION ? (
                <Notifications />
            ) : (
                isRightSidebarOpen === RightSidebar.BET_HISTORY && (
                    <BetHistory />
                )
            )}
        </div>
    )
}

export const App = () => {
    return (
        <div className={styles.container}>
            <Router>
                <ContextProvider>
                    <Header />
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/settings"
                            element={
                                <ProtectedRoute>
                                    <Settings />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/accounts"
                            element={
                                <ProtectedRoute>
                                    <Accounts />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/games"
                            element={
                                <ProtectedRoute>
                                    <Games />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/reports"
                            element={
                                <ProtectedRoute>
                                    <Reports />
                                </ProtectedRoute>
                            }
                        />
                        <Route path="/accounting" element={
                            <ProtectedRoute>
                                <Accounting />
                            </ProtectedRoute>
                        } />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Main />
                                </ProtectedRoute>
                            }
                        />
                    </Routes>
                </ContextProvider>
            </Router>
        </div>
    )
}
